import React from 'react';
import PropTypes from 'prop-types';

import {Grid2 as Grid, Box, Typography, Divider} from 'views/components';
import {Translate} from 'views/module';

// Lists the details of one contact method. The legacy notification, authentication, communication
// and Dialpad columns need the legacy channel loads, so this read-only copy has none of them.
const ContactMethod = (props) => {
  const {title, details} = props;

  return (
    <Box
      sx={{
        overflowX: {
          xs: 'auto',
          lg: 'visible',
        },
        maxWidth: '100%',
      }}
    >
      <Grid container spacing={1}>
        <Grid size={12}>
          <Typography variant="subtitle2">
            <Translate expression={title} />
          </Typography>
        </Grid>
        {
          details.length === 0 ? (
            <Grid size={12}>
              <Typography>
                <Translate expression='loomLead.LoomLeadDetail.Relationships.Contacts.NoneAdded' />
              </Typography>
            </Grid>
          ) : (
            details.map((detail) => (
              <Grid
                key={detail}
                size={12}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  minWidth: 0,
                }}
              >
                <Typography
                  sx={{
                    flex: 1,
                    minWidth: 0,
                    maxWidth: '100%',
                    overflowWrap: 'anywhere',
                    wordBreak: 'break-all',
                  }}
                >
                  {detail}
                </Typography>
              </Grid>
            ))
          )
        }
      </Grid>
    </Box>
  );
};

ContactMethod.propTypes = {
  title: PropTypes.string.isRequired,
  details: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const Contacts = (props) => {
  const {relationshipData} = props;

  // The adapter gives each relationship at most one Email and one Phone, but the legacy table was
  // keyed by detail, so duplicates collapse the same way here.
  const contactsTable = React.useMemo(() => {
    const contacts = relationshipData.contacts || [];
    const detailsOfType = (type) => {
      return [...new Set(contacts.filter((contact) => contact.type === type).map((contact) => contact.detail))];
    };

    return {
      emails: detailsOfType('Email'),
      phoneNumbers: detailsOfType('Phone'),
    };
  }, [relationshipData.contacts]);

  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          <Translate expression='loomLead.LoomLeadDetail.Relationships.Contacts.Title' />
        </Typography>
      </Grid>
      <Grid size={12}>
        <Divider />
      </Grid>

      {/* Emails */}
      <Grid size={12}>
        <ContactMethod
          title='loomLead.LoomLeadDetail.Relationships.Contacts.Email'
          details={contactsTable.emails}
        />
      </Grid>
      <Grid size={12}>
        <Divider />
      </Grid>

      {/* Phone Numbers */}
      <Grid size={12}>
        <ContactMethod
          title='loomLead.LoomLeadDetail.Relationships.Contacts.Phone'
          details={contactsTable.phoneNumbers}
        />
      </Grid>
    </Grid>
  );
};

Contacts.propTypes = {
  relationshipData: PropTypes.object.isRequired,
};

export default React.memo(Contacts);
